import {JobCancelColumnShort, JobCheckColumnShort, JobHoldColumnShort} from "./models";

export const jobCheckSortOption = [
    {
        label: "number_id",
        text: "number_id",
        value: JobCheckColumnShort.IDNumber.toString()
    },
    {
        label: "number_job",
        text: "number_job",
        value: JobCheckColumnShort.JobNumber.toString()
    },
    {
        label: "other_number",
        text: "other_number",
        value: JobCheckColumnShort.OtherNumber.toString()
    },
    {
        label: "kind_name",
        text: "kind_name",
        value: JobCheckColumnShort.KOJ.toString()
    },
    {
        label: "project_name",
        text: "project_name",
        value: JobCheckColumnShort.Project.toString()
    },
    {
        label: "status_name",
        text: "status_name",
        value: JobCheckColumnShort.Status.toString()
    },
    {
        label: "district_name",
        text: "district_name",
        value: JobCheckColumnShort.District.toString()
    },
    {
        label: "ts_created",
        text: "ts_created",
        value: JobCheckColumnShort.RequestDate.toString()
    },
    {
        label: "date_due",
        text: "date_due",
        value: JobCheckColumnShort.DueDate.toString()
    },
    {
        label: "last_check_date",
        text: "last_check_date",
        value: JobCheckColumnShort.LastCheckDate.toString()
    }
]

export const jobHoldSortOption = [
    {
        label: "number_id",
        text: "number_id",
        value: JobHoldColumnShort.IDNumber.toString()
    },
    {
        label: "number_job",
        text: "number_job",
        value: JobHoldColumnShort.JobNumber.toString()
    },
    {
        label: "other_number",
        text: "other_number",
        value: JobHoldColumnShort.OtherNumber.toString()
    },
    {
        label: "kind_name",
        text: "kind_name",
        value: JobHoldColumnShort.KOJ.toString()
    },
    {
        label: "project_name",
        text: "project_name",
        value: JobHoldColumnShort.Project.toString()
    },
    {
        label: "status_name",
        text: "status_name",
        value: JobHoldColumnShort.Status.toString()
    },
    {
        label: "district_name",
        text: "district_name",
        value: JobHoldColumnShort.District.toString()
    },
    {
        label: "ts_created",
        text: "ts_created",
        value: JobHoldColumnShort.RequestDate.toString()
    },
    {
        label: "date_due",
        text: "date_due",
        value: JobHoldColumnShort.DueDate.toString()
    },
]

export const jobCancelSortOption = [
    {
        label: "number_id",
        text: "number_id",
        value: JobCancelColumnShort.IDNumber.toString()
    },
    {
        label: "number_job",
        text: "number_job",
        value: JobCancelColumnShort.JobNumber.toString()
    },
    {
        label: "other_number",
        text: "other_number",
        value: JobCancelColumnShort.OtherNumber.toString()
    },
    {
        label: "kind_name",
        text: "kind_name",
        value: JobCancelColumnShort.KOJ.toString()
    },
    {
        label: "project_name",
        text: "project_name",
        value: JobCancelColumnShort.Project.toString()
    },
    {
        label: "status_name",
        text: "status_name",
        value: JobCancelColumnShort.Status.toString()
    },
    {
        label: "district_name",
        text: "district_name",
        value: JobCancelColumnShort.District.toString()
    },
    {
        label: "ts_created",
        text: "ts_created",
        value: JobCancelColumnShort.RequestDate.toString()
    },
    {
        label: "date_due",
        text: "date_due",
        value: JobCancelColumnShort.DueDate.toString()
    },
]